import React from "react";
const KS10SectionBHeader = () => {
  return (
    <div className="row mx-0">
      <div className="section-box">
        <div className="kr-title">
          <div className="form-check disabled">
            <input className="form-check-input" type="radio" disabled />
            <label className="form-check-label pl-3 pr-4">Section B</label>
          </div>
        </div>
        <div className="personal-details">
          <span className="title pr-3">Employment details</span>
          <div className="blockletterrs-whitebox">
            <div className="blockletterrs-use">Use</div>
            <div>
              <span>B</span>
              <span>L</span>
              <span>O</span>
              <span>C</span>
              <span>K</span>
              <span>L</span>
              <span>E</span>
              <span>T</span>
              <span>T</span>
              <span>E</span>
              <span>R</span>
              <span>S</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10SectionBHeader;
